import { isArray, isPlainObject } from 'lodash';
import { TBaseTag } from '../../components/CustomTag/types';
import { tagMutationSchema } from './tagMutationSchema';

export const childrenMutationSchemas = (children: TBaseTag['children']) => {
  if (isPlainObject(children)) {
    return tagMutationSchema(children as TBaseTag);
  } else if (isArray(children)) {
    return children.map(child => {
      if (isPlainObject(child)) return tagMutationSchema(child as TBaseTag);
      return child;
    });
  } else {
    return children;
  }
};
